<template>
  <div class="user">
    <header>
      <div class="headerTitle">学而思1对1介绍</div>
    </header>
    <section>
      <p>
        本《用户信息保护及隐私政策》（以下简称“本政策”或“本隐私政策”）适用于学而思网校旗下所有的产品及服务（以下简称“学而思网校”或“平台”）。
      </p>
      <p>
        您通过平台的产品及服务而接入的其他第三方产品或服务除外。请您务必在点击同意本政策之前，审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体标识，您应重点阅读。如您对政策有任何疑问，可按照本政策列明方式与学而思网校取得联系。
      </p>
      <p>
        当您点击确认同意本政策，即表示您已充分阅读、理解且接受本政策的全部内容，并与学而思网校达成一致，本政策对您及学而思网校均具有法律约束力。
      </p>
    </section>
  </div>
</template>

<script>
export default {
  name: "introduce",
};
</script>

<style lang="scss" scoped>
.user {
  .headerTitle {
    padding-top: 15px;
    font-weight: 500;
    text-align: center;
    font-size: 20px;
    color: #000c1d;
  }
  section {
    padding: 0 24px 24px 24px;
    p {
      font-size: 14px;
      color: #212832;
      line-height: 22px;
      padding: 24px 0 0 0;
      margin: 0;
    }
  }
}
</style>
